<template>
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="fill: currentColor"
  >
    <path
      d="M14.17 3.91L13.1 2.84L7.55 8.39V9.47H8.63L14.17 3.91ZM12 1.74L13.29 0.45C13.4286 0.30971 13.5936 0.198326 13.7756 0.122305C13.9576 0.0462843 14.1528 0.00713921 14.35 0.00713921C14.5472 0.00713921 14.7424 0.0462843 14.9244 0.122305C15.1064 0.198326 15.2714 0.30971 15.41 0.45L16.56 1.6C17.15 2.19 17.15 3.14 16.56 3.72L15.88 4.4L15.86 4.42L15.28 5L9.28 11H6V7.74L12 1.74ZM9.72 1.19L9.17 1.74L7.9 3.01C4.6 3.06 2 5.61 2 9.21C2 11.55 3.95 14.65 8 18.35C12.05 14.65 14 11.56 14 9.21V9.11L15.8 7.31C15.93 7.91 16 8.55 16 9.21C16 12.53 13.33 16.46 8 21.01C2.67 16.46 0 12.53 0 9.21C0 4.23 3.8 1.01 8 1.01C8.58 1.01 9.16 1.07 9.72 1.19Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
